export default {
    ricohBanner: 'メイクリープス株式会社は\nリコーグループの一員です',
};
